import { T }    from 'defa-object';
import Form     from 'scripts/poppet/form';
import template from 'templates/subscriptionTerminateChoiceForm.jst.html';

/**
 * defa.views.SubscriptionTerminateChoiceForm
 * A view for verifying subscription termination choices.
 * @version 1.2.0
 */

const selectors                       = {
	radioAll: '[data-input$=-radio]',
};
const SubscriptionTerminateChoiceForm = Form.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template: template,
	
	ui: {
		inputs: selectors.radioAll,
	},
	
	events: {
		'change @ui.inputs': 'onChangeInputs',
	},
	
	templateContext: function () {
		return {
			renewalDate: this.getRenewalDate(),
		};
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * Triggers when any input changes.
	 * @void
	 */
	onChangeInputs: function ( event ) {
		if ( event.target.id ) {
			this.selection = event.target.id;
			this.enableSubmit();
		} else {
			this.disableSubmit();
		}
	},
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Gets the date-formatted renewal date.
	 * @return {string} Translated human readable date formatted version of the validFrom date.
	 */
	getRenewalDate: function () {
		let date = new Date( this.model.get( 'transientExpirationDate' ) );
		return date.format( T.dateFormatShort );
	},
	
	/**
	 * Submits the form.
	 * @void
	 */
	submit: function () {
		this.trigger( 'ending:selected', this.selection );
	},
	
} );

export default SubscriptionTerminateChoiceForm;